import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Search, _CloseCircle;
var _excluded = ["className", "debounceDelay", "value", "onChange", "onSearch", "onClear"];
import React from 'react';
import CloseCircle from '@crehana/compass.icons.fill/CloseCircle';
import Search from '@crehana/compass.icons.outline/Search';
import { cn } from "../../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SearchInputVariant = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _value$toString;
  var className = _ref.className,
    _ref$debounceDelay = _ref.debounceDelay,
    debounceDelay = _ref$debounceDelay === void 0 ? 300 : _ref$debounceDelay,
    value = _ref.value,
    _onChange = _ref.onChange,
    onSearch = _ref.onSearch,
    onClear = _ref.onClear,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState((_value$toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value$toString !== void 0 ? _value$toString : ''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchValue = _React$useState2[0],
    setSearchValue = _React$useState2[1];

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (value !== undefined && !onSearch && !_onChange) console.warn('Do not use value without onChange or onSearch function. The value will be uncontrolled.');
  var usedValue = value !== undefined && !onSearch ? value.toString() : searchValue;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  React.useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!onSearch) return;

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (value === searchValue) return;
    var timer = setTimeout(function () {
      onSearch(searchValue);
    }, debounceDelay);
    return function () {
      return clearTimeout(timer);
    };
  }, [debounceDelay, value, searchValue]);
  var handleSearchClear = function handleSearchClear() {
    setSearchValue('');
    onClear === null || onClear === void 0 ? void 0 : onClear();
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-relative tw-flex tw-items-center",
    children: [/*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      className: cn('tw-pl-4.4 tw-pr-3.2', className),
      onChange: function onChange(e) {
        // biome-ignore lint/style/useBlockStatements: single-line early return
        if (_onChange) _onChange(e);
        setSearchValue(e.target.value);
      },
      value: usedValue
    }, props)), _Search || (_Search = /*#__PURE__*/_jsx(Search, {
      size: 24,
      className: "tw-absolute tw-left-1.2 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500"
    })), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: cn('tw-absolute tw-right-1.2 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500 hover:tw-text-primary-light-500 dark:hover:tw-text-primary-dark-400', usedValue.length === 0 && 'tw-hidden'),
      onClick: handleSearchClear,
      children: _CloseCircle || (_CloseCircle = /*#__PURE__*/_jsx(CloseCircle, {
        size: 16,
        className: "tw-text-inherit"
      }))
    })]
  });
});